var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 792,
    height: 200,
    viewBox: "0 0 792 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.338 -195.076L300.593 -176.908C302.438 -45.3708 444.703 35.9738 558.999 -29.1568L575.425 -38.5168C682.855 -99.7353 816.464 -22.6898 817.292 100.956L817.582 144.197C818.181 233.66 906.439 296.107 991.002 266.902V266.902",
    stroke: "url(#paint0_radial_1521_1400)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M294.313 -184.634L294.568 -166.466C296.413 -34.9284 438.679 46.4162 552.975 -18.7144L569.4 -28.0744C676.831 -89.2929 810.44 -12.2474 811.268 111.399L811.558 154.64C812.157 244.103 900.414 306.55 984.978 277.344V277.344",
    stroke: "url(#paint1_radial_1521_1400)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M288.284 -174.187L288.539 -156.019C290.384 -24.4812 432.65 56.8634 546.946 -8.26714L563.371 -17.6272C670.802 -78.8457 804.41 -1.80015 805.239 121.846L805.528 165.087C806.128 254.55 894.385 316.997 978.949 287.792V287.792",
    stroke: "url(#paint2_radial_1521_1400)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M282.253 -163.742L282.508 -145.574C284.353 -14.0368 426.618 67.3078 540.914 2.1772L557.34 -7.18283C664.77 -68.4013 798.379 8.64418 799.207 132.29L799.497 175.531C800.096 264.994 888.354 327.441 972.917 298.236V298.236",
    stroke: "url(#paint3_radial_1521_1400)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M276.227 -153.299L276.481 -135.131C278.326 -3.59348 420.592 77.7511 534.888 12.6206L551.314 3.26053C658.744 -57.958 792.353 19.0875 793.181 142.734L793.471 185.975C794.07 275.438 882.328 337.885 966.891 308.679V308.679",
    stroke: "url(#paint4_radial_1521_1400)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M270.195 -142.857L270.45 -124.689C272.295 6.84891 414.561 88.1935 528.857 23.0629L545.282 13.7029C652.713 -47.5156 786.321 29.5299 787.15 153.176L787.439 196.417C788.039 285.88 876.296 348.327 960.86 319.122V319.122",
    stroke: "url(#paint5_radial_1521_1400)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M264.162 -132.409L264.416 -114.241C266.262 17.2962 408.527 98.6408 522.823 33.5102L539.249 24.1502C646.679 -37.0683 780.288 39.9772 781.116 163.623L781.406 206.864C782.005 296.327 870.263 358.774 954.826 329.569V329.569",
    stroke: "url(#paint6_radial_1521_1400)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M258.133 -121.965L258.388 -103.797C260.233 27.7405 402.498 109.085 516.794 43.9545L533.22 34.5945C640.65 -26.624 774.259 50.4215 775.087 174.068L775.377 217.309C775.976 306.772 864.234 369.219 948.797 340.013V340.013",
    stroke: "url(#paint7_radial_1521_1400)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252.106 -111.523L252.361 -93.3548C254.206 38.1829 396.471 119.528 510.767 54.3969L527.193 45.0369C634.624 -16.1816 768.232 60.8639 769.06 184.51L769.35 227.751C769.949 317.214 858.207 379.661 942.77 350.456V350.456",
    stroke: "url(#paint8_radial_1521_1400)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M246.075 -101.08L246.329 -82.9124C248.175 48.6253 390.44 129.97 504.736 64.8393L521.162 55.4793C628.592 -5.73921 762.201 71.3063 763.029 194.952L763.319 238.194C763.918 327.656 852.176 390.103 936.739 360.898V360.898",
    stroke: "url(#paint9_radial_1521_1400)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M240.044 -90.635L240.299 -72.4671C242.144 59.0706 384.409 140.415 498.705 75.2846L515.131 65.9246C622.562 4.70611 756.17 81.7516 756.998 205.398L757.288 248.639C757.887 338.102 846.145 400.549 930.708 371.343V371.343",
    stroke: "url(#paint10_radial_1521_1400)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M234.017 -80.1906L234.272 -62.0227C236.117 69.5149 378.383 150.86 492.678 85.729L509.104 76.3689C616.535 15.1504 750.143 92.1959 750.972 215.842L751.261 259.083C751.861 348.546 840.118 410.993 924.682 381.788V381.788",
    stroke: "url(#paint11_radial_1521_1400)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M227.986 -69.7453L228.241 -51.5774C230.086 79.9602 372.351 161.305 486.647 96.1743L503.073 86.8142C610.503 25.5958 744.112 102.641 744.94 226.287L745.23 269.529C745.829 358.991 834.087 421.438 918.65 392.233V392.233",
    stroke: "url(#paint12_radial_1521_1400)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M221.953 -59.3029L222.207 -41.135C224.053 90.4026 366.318 171.747 480.614 106.617L497.04 97.2566C604.47 36.0381 738.079 113.084 738.907 236.73L739.197 279.971C739.796 369.434 828.054 431.881 912.617 402.675V402.675",
    stroke: "url(#paint13_radial_1521_1400)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M215.921 -48.8586L216.176 -30.6907C218.021 100.847 360.287 182.192 474.583 117.061L491.008 107.701C598.439 46.4825 732.047 123.528 732.876 247.174L733.165 290.415C733.765 379.878 822.022 442.325 906.586 413.12V413.12",
    stroke: "url(#paint14_radial_1521_1400)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M210.038 -38.6574L210.293 -20.4895C212.138 111.048 354.404 192.393 468.699 127.262L485.125 117.902C592.556 56.6836 726.164 133.729 726.993 257.375L727.282 300.616C727.882 390.079 816.139 452.526 900.703 423.321V423.321",
    stroke: "url(#paint15_radial_1521_1400)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M204.15 -28.466L204.405 -10.2981C206.25 121.24 348.515 202.584 462.811 137.454L479.237 128.094C586.667 66.8751 720.276 143.921 721.104 267.567L721.394 310.808C721.993 400.271 810.251 462.718 894.814 433.512V433.512",
    stroke: "url(#paint16_radial_1521_1400)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M198.267 -18.2658L198.522 -0.0979229C200.367 131.44 342.633 212.784 456.928 147.654L473.354 138.294C580.785 77.0752 714.393 154.121 715.222 277.767L715.511 321.008C716.111 410.471 804.368 472.918 888.932 443.712V443.712",
    stroke: "url(#paint17_radial_1521_1400)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M192.374 -8.06953L192.629 10.0984C194.474 141.636 336.74 222.981 451.036 157.85L467.461 148.49C574.892 87.2715 708.501 164.317 709.329 287.963L709.619 331.204C710.218 420.667 798.476 483.114 883.039 453.909V453.909",
    stroke: "url(#paint18_radial_1521_1400)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M186.484 2.12676L186.739 20.2947C188.584 151.832 330.85 233.177 445.146 168.046L461.571 158.686C569.002 97.4678 702.61 174.513 703.439 298.159L703.728 341.401C704.328 430.863 792.585 493.31 877.149 464.105V464.105",
    stroke: "url(#paint19_radial_1521_1400)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M180.603 12.3279L180.858 30.4958C182.703 162.033 324.969 243.378 439.265 178.248L455.691 168.887C563.121 107.669 696.73 184.714 697.558 308.361L697.848 351.602C698.447 441.064 786.705 503.511 871.268 474.306V474.306",
    stroke: "url(#paint20_radial_1521_1400)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M174.713 22.5262L174.968 40.6941C176.813 172.232 319.079 253.576 433.375 188.446L449.8 179.086C557.231 117.867 690.839 194.913 691.668 318.559L691.957 361.8C692.557 451.263 780.814 513.71 865.378 484.504V484.504",
    stroke: "url(#paint21_radial_1521_1400)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M168.823 32.7176L169.078 50.8855C170.923 182.423 313.189 263.768 427.485 198.637L443.91 189.277C551.341 128.059 684.949 205.104 685.778 328.75L686.067 371.991C686.667 461.454 774.924 523.901 859.488 494.696V494.696",
    stroke: "url(#paint22_radial_1521_1400)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M162.942 42.9158L163.197 61.0837C165.042 192.621 307.308 273.966 421.604 208.835L438.029 199.475C545.46 138.257 679.068 215.302 679.897 338.949L680.186 382.19C680.786 471.652 769.043 534.099 853.607 504.894V504.894",
    stroke: "url(#paint23_radial_1521_1400)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M157.05 53.1141L157.305 71.282C159.15 202.82 301.415 284.164 415.711 219.034L432.137 209.674C539.567 148.455 673.176 225.501 674.004 349.147L674.294 392.388C674.893 481.851 763.151 544.298 847.714 515.092V515.092",
    stroke: "url(#paint24_radial_1521_1400)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M151.164 63.3104L151.419 81.4782C153.264 213.016 295.53 294.361 409.826 229.23L426.252 219.87C533.682 158.651 667.291 235.697 668.119 359.343L668.409 402.584C669.008 492.047 757.266 554.494 841.829 525.289V525.289",
    stroke: "url(#paint25_radial_1521_1400)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M145.277 73.5105L145.532 91.6784C147.377 223.216 289.642 304.561 403.938 239.43L420.364 230.07C527.794 168.852 661.403 245.897 662.231 369.543L662.521 412.784C663.12 502.247 751.378 564.694 835.941 535.489V535.489",
    stroke: "url(#paint26_radial_1521_1400)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M139.389 83.7029L139.643 101.871C141.489 233.408 283.754 314.753 398.05 249.623L414.476 240.262C521.906 179.044 655.515 256.089 656.343 379.736L656.633 422.977C657.232 512.439 745.49 574.886 830.053 545.681V545.681",
    stroke: "url(#paint27_radial_1521_1400)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M133.503 93.9031L133.758 112.071C135.603 243.609 277.869 324.953 392.165 259.823L408.59 250.463C516.021 189.244 649.629 266.29 650.458 389.936L650.748 433.177C651.347 522.64 739.604 585.087 824.168 555.881V555.881",
    stroke: "url(#paint28_radial_1521_1400)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(652.71 23.7191) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(646.686 34.1615) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(640.656 44.6088) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(634.625 55.0531) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(628.599 65.4965) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(622.568 75.9389) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(616.534 86.3861) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(610.505 96.8305) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(604.478 107.273) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(598.447 117.715) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(592.416 128.161) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(586.389 138.605) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(580.358 149.05) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(574.325 159.493) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(568.294 169.937) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(562.41 180.138) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(556.522 190.329) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(550.639 200.53) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(544.747 210.726) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(538.857 220.922) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(532.976 231.123) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(527.086 241.322) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(521.195 251.513) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(515.315 261.711) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(509.422 271.91) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(503.537 282.106) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(497.649 292.306) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(491.761 302.498) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1521_1400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(485.876 312.699) rotate(120) scale(253.711 414.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4AFC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AFC38",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground1);
export default __webpack_public_path__ + "static/media/background1.c2d57062f2bbd58a7eaa392c977053c5.svg";
export { ForwardRef as ReactComponent };